import {
  RECEIVE_ADDRESS_FROM_ZIP,
} from '../actions/geo';

const initialState = {};

export default function geo(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_ADDRESS_FROM_ZIP:
      return action.data;
    default:
      return state;
  }
}
